//
//  DesignSystemVersion.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class DesignSystemVersionCreate {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.designSystemId = model.designSystemId;
        this.name = model.meta.name;
        this.description = model.meta.description;
        this.version = model.version;
        this.changeLog = ((_a = model.changeLog) === null || _a === void 0 ? void 0 : _a.length) > 0 ? model.changeLog : null;
        this.isReadonly = model.isReadonly;
        this.jobId = model.jobId;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b;
        return {
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            version: (_a = this.version) !== null && _a !== void 0 ? _a : null,
            designSystemId: this.designSystemId,
            isReadonly: this.isReadonly,
            meta: {
                name: this.name,
                description: this.description,
            },
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            changeLog: (_b = this.changeLog) !== null && _b !== void 0 ? _b : null,
            jobId: this.jobId,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        var _a, _b;
        return {
            version: (_a = this.version) !== null && _a !== void 0 ? _a : null,
            designSystemId: this.designSystemId,
            isReadonly: this.isReadonly,
            name: this.name,
            description: this.description,
            changeLog: (_b = this.changeLog) !== null && _b !== void 0 ? _b : null,
            jobId: this.jobId,
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        var _a, _b;
        return new DesignSystemVersionCreate({
            designSystemId: model.designSystemId,
            isReadonly: model.isReadonly,
            meta: {
                name: model.name,
                description: model.description,
            },
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            version: (_a = model.version) !== null && _a !== void 0 ? _a : null,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            changeLog: (_b = model.changeLog) !== null && _b !== void 0 ? _b : null,
            jobId: model.jobId,
        });
    }
}
export class DesignSystemVersion {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.designSystemId = model.designSystemId;
        this.name = model.meta.name;
        this.description = model.meta.description;
        this.version = model.version;
        this.changeLog = ((_a = model.changeLog) === null || _a === void 0 ? void 0 : _a.length) > 0 ? model.changeLog : null;
        this.isReadonly = model.isReadonly;
        this.createdAt = new Date(model.createdAt);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a, _b;
        return {
            id: this.id,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            version: (_a = this.version) !== null && _a !== void 0 ? _a : null,
            designSystemId: this.designSystemId,
            isReadonly: this.isReadonly,
            meta: {
                name: this.name,
                description: this.description,
            },
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            changeLog: (_b = this.changeLog) !== null && _b !== void 0 ? _b : null,
            createdAt: this.createdAt.toISOString(),
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        var _a, _b;
        return {
            id: this.id,
            version: (_a = this.version) !== null && _a !== void 0 ? _a : null,
            designSystemId: this.designSystemId,
            isReadonly: this.isReadonly,
            name: this.name,
            description: this.description,
            changeLog: (_b = this.changeLog) !== null && _b !== void 0 ? _b : null,
            createdAt: this.createdAt.toISOString(),
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        var _a, _b;
        return new DesignSystemVersion({
            id: model.id,
            designSystemId: model.designSystemId,
            isReadonly: model.isReadonly,
            meta: {
                name: model.name,
                description: model.description,
            },
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            version: (_a = model.version) !== null && _a !== void 0 ? _a : null,
            createdAt: model.createdAt,
            // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
            changeLog: (_b = model.changeLog) !== null && _b !== void 0 ? _b : null,
        });
    }
}
export class DesignSystemVersionCreationJob {
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.version = model.version;
        this.designSystemId = model.designSystemId;
        this.designSystemVersionId = (_a = model.designSystemVersionId) !== null && _a !== void 0 ? _a : null;
        this.status = model.status;
        this.message = (_b = model.message) !== null && _b !== void 0 ? _b : null;
    }
}
